import { useId } from "react";

import { useMotionStore, type MotionSetting } from "../../../app/motion";
import { Card } from "../../../ui/Card";

const CHOICES: Array<{ value: MotionSetting; label: string; hint: string }> = [
  { value: "system", label: "As my computer", hint: "Follow the setting for reduced motion on this computer." },
  { value: "on", label: "On", hint: "New elements pop in and states fade from one colour to the next." },
  { value: "off", label: "Off", hint: "Nothing moves. Changes simply appear." },
];

/** The switch that turns all motion off (ui-direction, visual language). It is kept in this browser. */
export function MotionChoice() {
  const name = useId();
  const setting = useMotionStore((state) => state.setting);
  const choose = useMotionStore((state) => state.choose);
  return (
    <Card className="ra-section" aria-labelledby="ra-motion-title">
      <h2 id="ra-motion-title">Motion</h2>
      <p className="muted">All motion can be turned off. This choice is kept in this browser.</p>
      <div role="radiogroup" aria-labelledby="ra-motion-title" className="stack">
        {CHOICES.map((choice) => (
          <label key={choice.value} className="ra-radio">
            <input type="radio" name={name} value={choice.value} checked={setting === choice.value} onChange={() => choose(choice.value)} />{" "}
            <strong>{choice.label}</strong> <span className="muted">{choice.hint}</span>
          </label>
        ))}
      </div>
    </Card>
  );
}
